<script setup lang="ts">
import PageHeader from "~/components/layout/PageHeader.vue";
import {type IScheduledEvent} from "~/data/events";
import {isDone} from "~/functions/isDone";
import LeftDays from "~/components/partials/LeftDays.vue";
import {useEventTZDate} from "~/computed/useEventTZDate";

const $props = defineProps<{
  title: string
  description: string
  scheduledEvent: IScheduledEvent
}>()
const $route = useRoute();

const isEventDone = computed(() => isDone($props.scheduledEvent));
const calendarLink = computed(() => {
  const dates = useEventTZDate($props.scheduledEvent);
  const dFormat = `YYYYMMDDTHHmmss`;
  let timezone = 'Europe/Moscow';
  try {
    timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  }catch(e) {
    console.error(e)
  }

  return encodeURI('https://www.google.com/calendar/event?action=TEMPLATE&' +
      [
        `text=${$props.scheduledEvent.title}`,
        `dates=${dates.startDate.format(dFormat)}/${dates.endDate.format(dFormat)}`,
        `details=${$props.scheduledEvent.description || 'Событие'}`,
        `location=Moscow`,
        `trp=false`,
        `sprop=website:https://conf.xsquare.ru/`,
        `ctz=${timezone}`
      ].join("&")
  )
});
const eventDate = useEventTZDate($props.scheduledEvent);

const regLink = ref("");
onMounted(() => regLink.value = getRegLink() || '');
watch(() => $route, () => regLink.value = getRegLink() || '', { deep: true });
onMounted(() => setTimeout(() => regLink.value = getRegLink() || '', 200));

function getRegLink() {
  try {
    const originalULR = $props.scheduledEvent.regLink;
    if(!originalULR) return "";
    if(!Object.keys(typeof $route?.query === "object" ? $route?.query : {})?.length) return originalULR;

    const link = String(originalULR);
    const query = String(link.split("?")[1] || '') || '';

    let parameters =  query.split("&") || [];
    for(const key of Object.keys($route.query)) {
      const value = $route.query[key];
      if(Array.isArray(value)) {
        for(const arrValue of value) {
          parameters.push(`${key}=${arrValue}`);
        }
      } else {
        parameters.push(`${key}=${value}`);
      }
    }
    parameters = parameters.filter(i => !!i);

    if(parameters.length === 0) return originalULR;
    return `${link.split("?")[0]}?${parameters.join("&")}`;
  } catch(e) {
    console.error(e)
    return $props.scheduledEvent?.regLink;
  }
}
</script>

<template>
  <page-header
      :h1="title"
      :h2="description"
      :show-more-button="true"
  >
    <template #before-h1>
      <nuxt-link to="/" class="link link--event-back"><Icon name="icon-arrow-left"/> Все события</nuxt-link>
    </template>

    <template #h1>
      <h1 class="event-page-title">
        {{ title }}

        <left-days :scheduled-event="scheduledEvent" />
      </h1>

      <p class="event-page-date" v-html="eventDate.period"></p>

      <div class="event-page-reg-btns" v-if="!isEventDone">
        <template v-if="!!regLink || !!scheduledEvent.regLink">
          <a :href="regLink || scheduledEvent.regLink" target="_blank" class="btn event-page-reg-btn">Зарегистрироваться</a>
        </template>
        <a v-if="false" :href="calendarLink" title="Добавить в календарь Google" target="_blank" class="btn event-page-reg-btn event-page-reg-btn--calendar">
          <Icon name="icon-calendar"/>
        </a>
      </div>
    </template>

    <template #content>
      <slot name="content" />
      <template
          v-if="scheduledEvent?.hideOlineVideo !== true && !(scheduledEvent?.hideOnlineVideoBeforeEnd === true && !isEventDone)"
      >
        <div v-if="!!scheduledEvent.record" class="event-record-wrapper">
          <div class="event-record">
            <iframe
                width="720"
                height="405"
                :src="scheduledEvent.record"
                frameBorder="0"
                allow="clipboard-write; autoplay"
                webkitAllowFullScreen
                mozallowfullscreen
                allowFullScreen
            ></iframe>
          </div>
        </div>
        <div v-else class="empty-record">
          <Lottie src="/lottie/video.lottie" :speed="1.2"/>
          <p v-if="!isEventDone">Ссылка на онлайн-трансляцию скоро появится</p>
          <p v-else>Запись события скоро появится</p>
        </div>
      </template>
    </template>
  </page-header>
</template>

<style scoped lang="scss">

</style>